import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics';
import { Capacitor } from '@capacitor/core';

export const hapticFeedback = {
  // Light impact for subtle interactions
  light: async () => {
    if (Capacitor.isNativePlatform()) {
      try {
        await Haptics.impact({ style: ImpactStyle.Light });
      } catch (error) {
        console.log('Haptics not available:', error);
      }
    }
  },

  // Medium impact for standard button presses
  medium: async () => {
    if (Capacitor.isNativePlatform()) {
      try {
        await Haptics.impact({ style: ImpactStyle.Medium });
      } catch (error) {
        console.log('Haptics not available:', error);
      }
    }
  },

  // Heavy impact for important actions
  heavy: async () => {
    if (Capacitor.isNativePlatform()) {
      try {
        await Haptics.impact({ style: ImpactStyle.Heavy });
      } catch (error) {
        console.log('Haptics not available:', error);
      }
    }
  },

  // Success notification
  success: async () => {
    if (Capacitor.isNativePlatform()) {
      try {
        await Haptics.notification({ type: NotificationType.Success });
      } catch (error) {
        console.log('Haptics not available:', error);
      }
    }
  },

  // Warning notification
  warning: async () => {
    if (Capacitor.isNativePlatform()) {
      try {
        await Haptics.notification({ type: NotificationType.Warning });
      } catch (error) {
        console.log('Haptics not available:', error);
      }
    }
  },

  // Error notification
  error: async () => {
    if (Capacitor.isNativePlatform()) {
      try {
        await Haptics.notification({ type: NotificationType.Error });
      } catch (error) {
        console.log('Haptics not available:', error);
      }
    }
  }
};

// Custom hook for button haptics
export const useButtonHaptics = () => {
  const handlePress = (intensity: 'light' | 'medium' | 'heavy' = 'medium') => {
    hapticFeedback[intensity]();
  };

  return { handlePress };
};